export enum RoutePath {
  BasePath = '',
  OverviewPath = 'overview',
  MaterialsGPT = 'materials-gpt',
  AQMCalculatorPath = 'aqm-calculator',
  InsulationSolutionsPath = 'insulation-solutions',
  MaterialPropertiesEstimator = 'material-properties-estimator',
  MaterialsSupplierDatabasePath = 'materials-supplier-database',
  CCTCalculatorPath = 'continous-cooling-transformation',
  SubstanceInformationSystemPath = 'substance-information-system',
  LearnMorePath = 'learn-more',
  ForbiddenPath = 'forbidden',
}

export enum RouteNames {
  Base = 'Materials App Center',
  Overview = 'Overview',
  HardnessConverter = 'Hardness Converter',
  MaterialsGPT = 'Materials GPT',
  AQMCalculator = 'AQM Calculator',
  InsulationSolutions = 'Insulation Solutions',
  MaterialsSupplierDatabase = 'Materials Supplier Database',
  MaterialPropertiesEstimator = 'Material Properties Estimator',
  LearnMore = 'Learn More',
  Forbidden = 'forbidden',
}
